import * as React from 'react';
import NetworkApi from '../../api/NetworkApi';
import paths from '../../api/paths';
import useAsync from '../../hooks/useAsync';
import { useEffect } from 'react';
import { get } from 'lodash';

const useLoans = () => {
  const [params, setParams] = React.useState(null);
  const generateToken = useAsync(null, null);
  const authenticateCode = useAsync(
    ({ data }) => ({
      ...data,
      token: data.access_token,
      realms: [{ realmIdentifier: data.realmId }],
      realmIdentifier: data.realmId,
      env: 'agnet'
    }),
    null
  );
  const profileAsync = useAsync((data) => {
    const formData: any = get(data, 'data.payload.formDefinition.formData', {});
    return {
      contactNumber: get(formData, 'mobileNumber', undefined),
      ...formData,
      userName: decodeURIComponent(params.name)
    };
  }, null);

  useEffect(() => {
    if (generateToken.state.isSuccess) {
      const data = get(generateToken, 'state.data', {});
      getAuthenticationCode(data.code);
    }
  }, [generateToken.state.isSuccess]);

  useEffect(() => {
    if (authenticateCode.state.isSuccess) {
      getProfileInfo(authenticateCode.state.data);
    }
  }, [authenticateCode.state.isSuccess]);

  const generateCode = ({ access_token, token_type }, params) => {
    generateToken.run(NetworkApi.post, paths.generate_code, params, {
      Authorization: `${token_type} ${access_token}`,
      Accept: 'application/json'
    });
  };

  const getAuthenticationCode = (code) => {
    authenticateCode.run(
      NetworkApi.post,
      paths.signInCode(),
      {
        code
      },
      {
        Accept: 'application/json'
      }
    );
  };

  const getProfileInfo = (data) => {
    const postData = {
      requestId: data.userId,
      userId: data.userId,
      workflowName: 'UserProfileDetailsDisplay_Workflow',
      dataMap: { input: {} }
    };
    profileAsync.run(
      NetworkApi.post,
      paths.profile(data.userId, data.realmId),
      postData,
      {
        Authorization: `${data.token_type} ${data.access_token}`
      }
    );
  };

  return {
    generateCode,
    setParams,
    isFailed:
      authenticateCode.state.isFailed ||
      generateToken.state.isFailed ||
      profileAsync.state.isFailed,
    isSuccess: profileAsync.state.isSuccess,
    data: {
      ...authenticateCode.state.data,
      ...profileAsync.state.data
    },
    params
  };
};

export default useLoans;
